import markupProvider from './cardData/provider';
import { lazyLoadComponent } from '../../utils';

export default async (id) => {
	const namespace = 'SidepanelModalCard';
	const Card = await lazyLoadComponent(namespace, 'Card');
	let props = {};
	switch (id) {
	case 'infoMAP':
		props = {
			rows: [
				{
					component: await lazyLoadComponent(namespace, 'ContentRow'),
					props: {
						id: 'info_about',
						title: 'Informácie o aplikácii Mapka',
						body: await markupProvider('info_about'),
					},
				},
			]
		};
		break;
	case 'howto':
		props = {
			rows: [
				{
					component: await lazyLoadComponent(namespace, 'ContentRow'),
					props: {
						id: 'howto',
						title: 'Ako pracovať s Mapkou',
						body: await markupProvider('howto'),
					},
				},
			]
		};
		break;
	case 'sources':
			props = {
				rows: [
					{
						component: await lazyLoadComponent(namespace, 'ContentRow'),
						props: {
							id: 'sources',
							title: 'Zdroje nárečových ukážok',
							body: await markupProvider('sources'),
						},
					},
				]
			};
			break;
	case 'explorators':
		props = {
			rows: [
					{
						component: await lazyLoadComponent(namespace, 'ContentRow'),
						props: {
							id: 'explorators',
							title: 'Prehľad nárečových ukážok',
							body: await markupProvider('explorators'),
						},
					},
				]
				};
				break;
	case 'kudosGoTo':
				props = {
					rows: [
						{
							component: await lazyLoadComponent(namespace, 'ContentRow'),
							props: {
								id: 'kudosGoTo',
								title: 'Poďakovanie',
								body: await markupProvider('kudosGoTo'),
							},
						},
					]
				};
				break;
	case 'media':
				props = {
					rows: [
						{
							component: await lazyLoadComponent(namespace, 'ContentRow'),
							props: {
								id: 'media',
								title: 'Mapka v médiách',
								body: await markupProvider('media'),
							},
						},
					]
				};
				break;
	case 'contact':
		props = {
			rows: [
				{
					component: await lazyLoadComponent(namespace, 'ContentRow'),
					props: {
						id: 'contact',
						title: 'Kontakt',
						body: await markupProvider('contact'),
					},
				},
			]
		};
		break;
	case 'moreLinks':
		props = {
			rows: [
				{
					component: await lazyLoadComponent(namespace, 'ContentRow'),
					props: {
						id: 'moreLinks',
						title: 'Ďalšie nárečové zdroje',
						body: await markupProvider('moreLinks'),
					},
				},
			]
		};
		break;
	default:
		break;
	}

	return new Card(props);
};
